import { GridCell } from '@almbrand/grid';
import classNames from 'classnames';
import { Component } from 'components/Component';

export const GridCellComponent: React.FC<{
	component: ContentApiModel;
	applySpacings?: boolean;
	noGutter?: boolean;
	className?: string;
}> = ({ component, applySpacings, noGutter, className }) => {
	const { gridSize, tabletGridSize, mobileGridSize, gridMove, mobileGridMove, tabletGridMove } =
		component?.grid ?? {};

	const getGridSize = (size?: GridCellWidth | 'None', defaultSize?: GridCellWidth) => {
		return !size || size === 'None' ? defaultSize : size;
	};

	const getOffset = (offset?: GridCellWidth | 'None') => {
		return !offset || offset === 'None' ? gridMove : offset;
	};

	const { marginBottom, marginTop } = component?.style ?? {};

	return (
		<GridCell
			desktopWidth={gridSize}
			tabletWidth={getGridSize(tabletGridSize, gridSize)}
			mobileWidth={getGridSize(mobileGridSize, '12col')}
			desktopOffset={gridMove}
			tabletOffset={getOffset(tabletGridMove)}
			mobileOffset={mobileGridMove}
			className={classNames(className, applySpacings && [`pt-${marginTop}`, `pb-${marginBottom}`])}
			nogutter={noGutter}
		>
			<Component {...component?.content} />
		</GridCell>
	);
};
